import { useState } from 'react'
import { useAspectRatioSwitch } from 'hooks/useAspectRatioSwitch'
import { ASPECT_RATIO_WARNING_STORAGE_KEY } from 'consts'

export const useAspectRatioWarning = () => {
  const { canSwitch, getOppositeAspectRatio, performSwitch } =
    useAspectRatioSwitch()
  const [showWarning, setShowWarning] = useState(false)
  const [pendingSelection, setPendingSelection] = useState<
    'landscape' | 'portrait' | null
  >(null)

  const handleAspectRatioClick = (targetKey?: 'landscape' | 'portrait') => {
    if (!canSwitch) {
      return
    }

    const actualTargetKey =
      typeof targetKey === 'string' ? targetKey : undefined
    const newKey = actualTargetKey || getOppositeAspectRatio()
    const hasSeenWarning = sessionStorage.getItem(
      ASPECT_RATIO_WARNING_STORAGE_KEY
    )

    if (!hasSeenWarning) {
      setPendingSelection(newKey)
      setShowWarning(true)
      return
    }

    performSwitch(newKey)
  }

  const handleConfirmSwitch = () => {
    sessionStorage.setItem(ASPECT_RATIO_WARNING_STORAGE_KEY, 'true')

    const isPerformSwitch =
      pendingSelection &&
      (pendingSelection === 'landscape' || pendingSelection === 'portrait')

    if (isPerformSwitch) {
      performSwitch(pendingSelection)
    }

    setShowWarning(false)
    setPendingSelection(null)
  }

  const handleCancelSwitch = () => {
    setShowWarning(false)
    setPendingSelection(null)
  }

  return {
    canSwitch,
    handleAspectRatioClick,
    showWarning,
    pendingSelection,
    handleConfirmSwitch,
    handleCancelSwitch
  }
}
